import DropdownMenu from './DropdownMenu'
import Divider from './DropdownMenuDivider'
import Item from './DropdownMenuItem'

DropdownMenu.Divider = Divider
DropdownMenu.Item = Item

export default DropdownMenu
